if (typeof window.GiftNavigation === 'undefined') {
  window.GiftNavigation = class GiftNavigation {
    static SCROLL_BUFFER = 200; // スクロール位置のバッファ（ピクセル）

    constructor(container) {
      this.container = container;
      this.buttons = container.querySelectorAll('.fac-gift-navigation__link');
      this.init();
    }

    init() {
      // 各ボタンにクリックイベントを設定
      this.buttons.forEach((button) => {
        button.addEventListener('click', (e) => this.handleClick(e));
      });
    }

    static activateTab(targetId) {
      // 全てのpage-giftからactiveクラスを除去
      document.querySelectorAll('.page-gift').forEach((element) => {
        element.classList.remove('active');
      });

      // 全てのナビゲーションの全てのボタンとその親要素からactiveクラスを除去
      document.querySelectorAll('.fac-gift-navigation__link').forEach((button) => {
        button.classList.remove('active');
        const item = button.closest('.fac-gift-navigation__item');
        if (item) {
          item.classList.remove('active');
        }
      });

      // 同じdata-targetを持つ全てのボタンと親要素をactive化
      document.querySelectorAll(`.fac-gift-navigation__link[data-target="${targetId}"]`).forEach((button) => {
        button.classList.add('active');
        const item = button.closest('.fac-gift-navigation__item');
        if (item) {
          item.classList.add('active');
        }
      });

      // 対象の要素をactive化
      const targetElement = document.getElementById(targetId);
      if (targetElement && targetElement.classList.contains('page-gift')) {
        targetElement.classList.add('active');
      }
    }

    static scrollToNavigation(topNav) {
      const navHeight = topNav.offsetHeight;
      const navTop = topNav.getBoundingClientRect().top + window.pageYOffset;
      const scrollToPosition = Math.max(navTop - navHeight - window.GiftNavigation.SCROLL_BUFFER, 0);

      window.scrollTo({
        top: scrollToPosition,
        behavior: 'smooth',
      });
    }

    handleClick(e) {
      const clickedButton = e.currentTarget;
      const targetId = clickedButton.getAttribute('data-target');

      if (!targetId) return;

      // URLハッシュを更新（hashchangeイベントがスクロール処理を実行）
      history.pushState(null, '', `#${targetId}`);
      // ページ遷移ではなくハッシュ更新なので、hashchangeイベントをマニュアルで発火
      window.dispatchEvent(new HashChangeEvent('hashchange'));
    }
  };
}

// 初期化処理
document.addEventListener('DOMContentLoaded', () => {
  // ページ内の全てのfac-gift-navigationを初期化
  document.querySelectorAll('.fac-gift-navigation').forEach((nav) => {
    new window.GiftNavigation(nav);
  });

  // 初期タブの設定（1回だけ実行）
  const hash = window.location.hash.substring(1);
  const allButtons = document.querySelectorAll('.fac-gift-navigation__link');
  let targetId = null;

  if (hash) {
    // ハッシュに対応するボタンがあればそのターゲットを使用
    const matchButton = Array.from(allButtons).find((button) => button.getAttribute('data-target') === hash);
    if (matchButton) {
      targetId = hash;
    }
  }

  // ターゲットが見つからなければ最初のボタンのターゲットを使用
  if (!targetId && allButtons.length > 0) {
    targetId = allButtons[0].getAttribute('data-target');
  }

  // タブをアクティブ化
  if (targetId) {
    window.GiftNavigation.activateTab(targetId);
  }

  // ハッシュがある場合はスクロール処理をトリガー
  if (hash) {
    window.dispatchEvent(new HashChangeEvent('hashchange'));
  }
});

// ハッシュ変更時のスクロール処理（全ての場面を統一）
window.addEventListener('hashchange', () => {
  const hash = window.location.hash.substring(1);
  if (hash) {
    const allButtons = document.querySelectorAll('.fac-gift-navigation__link');
    const matchButton = Array.from(allButtons).find((button) => button.getAttribute('data-target') === hash);

    if (matchButton) {
      window.GiftNavigation.activateTab(hash);

      // バッファ付きスクロール処理
      requestAnimationFrame(() => {
        const allNavs = Array.from(document.querySelectorAll('.fac-gift-navigation'));
        if (allNavs.length > 0) {
          window.GiftNavigation.scrollToNavigation(allNavs[0]);
        }
      });
    }
  }
});
